import {
  browserFastApiClient,
  requireFastApiAccessToken,
} from "@/core/fastapi";
import {
  deleteVersionsApiCrud,
  type DeleteVersionsRequest,
} from "@/generated/fastapi";

export async function deleteVersions(
  accessToken: string | null | undefined,
  request: DeleteVersionsRequest,
) {
  const response = await deleteVersionsApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to delete version(s) (${response.status})`);
  }

  return response.data;
}
